var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reminder",class:{ active: _vm.taskInfo.secKillRemainStatus === 1 },on:{"click":_vm.toggleRemind}},[_c('i',{staticClass:"round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }